
<div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <label class="usa-legend usa-legend--medium">HHG Upload Rate File</label>
    </div>
</div>
<app-upload [businessType]="'hhg'"></app-upload>